<mat-sidenav-container>
  <mat-sidenav
    #drawer
    fixedInViewport="true"
    [attr.role]="(isHandset$ | async) || (isIpadVertical$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) || (isIpadVertical$ | async) ? 'over' : 'side'"
    [autoFocus]="false"
    >
    <!-- スマホかつアーティスト情報持ってる場合、スマホMENUを表示する -->
    @if (
      (isArtistPage$ | async) && ((isHandset$ | async) || (isIpadVertical$ | async))) {
      @if (selectedArtist$ | async; as artist) {
        <div class="sidenav-arsha">
          @if (artist.arsha) {
            <img class="arsha" [src]="artist.arsha" />
          }
          @if (!artist.arsha) {
            <div class="arsha-empty" fxLayout fxLayoutAlign="center center">
              <div class="empty-label">{{ artist.nameMain }}</div>
            </div>
          }
        </div>
      }
      <mat-action-list class="top-menu">
        <div fxLayout="column">
          <div class="profile-title">
            <mat-icon>person</mat-icon>
            <span>プロファイル</span>
          </div>
          @if (selectedArtist$ | async; as artist) {
            <ng-container
              *ngTemplateOutlet="profileItem; context: { legend: '名前', value: artist.nameMain }"
            ></ng-container>
            @if (artist.nameSub) {
              <ng-container
                *ngTemplateOutlet="profileItem; context: { legend: '', value: artist.nameSub }"
              ></ng-container>
            }
            <ng-container
              *ngTemplateOutlet="profileItem; context: { legend: 'ジャンル', value: artist.genre }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="profileItem; context: { legend: 'レーベル', value: artist.label }"
            ></ng-container>
          }
        </div>
      </mat-action-list>
      <mat-action-list class="top-menu">
        <button mat-list-item routerLink="/home">
          <mat-icon>search</mat-icon>
          <span>検索</span>
        </button>
      </mat-action-list>
      <mat-action-list class="top-menu">
        <button mat-list-item (click)="onInfoClick()" class="top-menu-button">
          <mat-icon>info_outlined</mat-icon>
          <span class="toolbar-button-label">お知らせ</span>
        </button>
      </mat-action-list>
      <mat-action-list class="top-menu">
        <button mat-list-item (click)="onInquiryClick()" class="top-menu-button">
          <mat-icon>group_add</mat-icon>
          <span class="toolbar-button-label">アーティスト追加要望</span>
        </button>
      </mat-action-list>
      <footer>
        <mat-list class="top-menu">
          <div class="auth_button_sign_out_sp">
            <mat-icon class="material-icons">account_circle</mat-icon>
            <input
              class="auth_button_sign_out"
              type="button"
              value="サインアウト"
              onclick="signOut();"
              />
            </div>
          </mat-list>
        </footer>
        <!--
        <footer>
          <mat-list class="top-menu">
            <mat-list-item>
              <mat-icon class="material-icons">account_circle</mat-icon>
              <span>ユーザ名</span>
              <span class="spacer"></span>
              <button mat-button color="warn">
                <mat-icon>exit_to_app</mat-icon>
                <span class="toolbar-button-label">サインアウト</span>
              </button>
            </mat-list-item>
          </mat-list>
        </footer>
        -->
      } @else {
        <mat-action-list class="top-menu">
          <button mat-list-item (click)="onInfoClick()" class="top-menu-button">
            <mat-icon>info_outlined</mat-icon>
            <span class="toolbar-button-label">お知らせ</span>
          </button>
        </mat-action-list>
        <mat-action-list class="top-menu">
          <button mat-list-item (click)="onInquiryClick()" class="top-menu-button">
            <mat-icon>group_add</mat-icon>
            <span class="toolbar-button-label">アーティスト追加要望</span>
          </button>
        </mat-action-list>
        <footer>
          <mat-list class="top-menu">
            <div class="auth_button_sign_out_sp">
              <mat-icon class="material-icons">account_circle</mat-icon>
              <input
                class="auth_button_sign_out"
                type="button"
                value="サインアウト"
                onclick="signOut();"
                />
              </div>
            </mat-list>
          </footer>
          <!--
          <footer>
            <mat-list class="top-menu">
              <mat-list-item>
                <mat-icon class="material-icons">account_circle</mat-icon>
                <span>ユーザ名</span>
                <span class="spacer"></span>
                <button mat-button color="warn">
                  <mat-icon>exit_to_app</mat-icon>
                  <span class="toolbar-button-label">サインアウト</span>
                </button>
              </mat-list-item>
            </mat-list>
          </footer>
          -->
        }
      </mat-sidenav>
      <mat-sidenav
        class="event-drawer"
        #events
        fixedInViewport="true"
        [attr.role]="(isHandset$ | async) || (isIpadVertical$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) || (isIpadVertical$ | async) ? 'over' : 'side'"
        [opened]="isEventDrawerOpened$ | async"
        position="end"
        >
        <!-- PCかつアーティスト情報持ってる場合、EVENT MENUを表示する -->
        @if ((isArtistPage$ | async) && !((isHandset$ | async) || (isIpadVertical$ | async))) {
          <app-events
          ></app-events>
        }
      </mat-sidenav>
      <mat-sidenav-content cdkScrollable>
        <!--
  スマホかつアーティスト情報持ってる場合、スマホアーティストバーを表示する
  スマホトップ画面の場合、スマホトップバーを表示する
  -->
        <ng-template #noMenu></ng-template>
        @if (
        (isArtistPage$ | async) && ((isHandset$ | async) || (isIpadVertical$ | async))) {
        <mat-toolbar class="appbar" [class.mat-elevation-z4]="isScrolled$ | async">
          <mat-toolbar-row>
            <button aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
              <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
            <div class="spacer"></div>
            @if (loaded$ | async) {
            <div class="menu-title">
              {{ (selectedArtist$ | async)?.nameMain }}
            </div>
            } @else {
            <div class="menu-title">
              {{ title$ | async }}
            </div>
            }
            <div class="spacer"></div>
            @if (!(isXSmallVertical$ | async) && (isIpadVertical$ | async)) {
            <!-- <button mat-button [matMenuTriggerFor]="dateRangeMenu"> -->
            <input matInput
                   class="date-picker-hidden-input"
                   [matDatepicker]="picker"
                   [matDatepickerFilter]="dateRangeInputFilter"
                   [formControl]="criteriaFromField"
                   (dateChange)="onDateRangeChange()"
                   />
            <mat-datepicker #picker
                            [dateClass]="highlightDate"
                            (closed)="onDateRangeMenuClose()"></mat-datepicker>
            <button mat-button (click)="picker.open()">
              <mat-icon>date_range</mat-icon>
              <span class="toolbar-button-label date-range-label">
                {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
                ~
                {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
              </span>
            </button>
            <button mat-button (click)="openEventBottomSheet()">
              <mat-icon>events</mat-icon>
              <span class="toolbar-button-label">出来事</span>
            </button>
            }
            <button mat-icon-button routerLink="/home">
              <mat-icon>home</mat-icon>
            </button>
            <ng-container *ngTemplateOutlet="menu ? menu : noMenu"></ng-container>
          </mat-toolbar-row>
          @if (isXSmallVertical$ | async) {
          <mat-toolbar-row>
            <!-- <button mat-button [matMenuTriggerFor]="dateRangeMenu"> -->
            <div class="spacer"></div>
            <input matInput
                   class="date-picker-hidden-input"
                   [matDatepicker]="picker"
                   [matDatepickerFilter]="dateRangeInputFilter"
                   [formControl]="criteriaFromField"
                   (dateChange)="onDateRangeChange()"
                   />
            <mat-datepicker #picker
                            [dateClass]="highlightDate"
                            (closed)="onDateRangeMenuClose()"></mat-datepicker>
            <button mat-button (click)="picker.open()">
              <mat-icon>date_range</mat-icon>
              <span class="toolbar-button-label date-range-label">
                {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
                ~
                {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
              </span>
            </button>
            <div class="spacer"></div>
            <button mat-button (click)="openEventBottomSheet()">
              <mat-icon>events</mat-icon>
              <span class="toolbar-button-label">出来事</span>
            </button>
            <div class="spacer"></div>
          </mat-toolbar-row>
          }
        </mat-toolbar>
        } @else {
        @if ((isHandset$ | async) || (isIpadVertical$ | async)) {
        <mat-toolbar class="appbar"
                     [class.mat-elevation-z4]="isScrolled$ | async">
          <mat-toolbar-row>
            <button aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
              <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
            <div class="spacer"></div>
            <div class="title">
              <a routerLink="/">{{ title$ | async }}</a>
            </div>
            <div class="spacer"></div>
          </mat-toolbar-row>
        </mat-toolbar>
        }
        }
        <!-- PC場合、PC バーを表示する -->
        @if (!((isHandset$ | async) || (isIpadVertical$ | async))) {
        <mat-toolbar class="appbar"
                     [class.mat-elevation-z4]="isScrolled$ | async">
          <mat-toolbar-row>
            <div>
              <mat-icon class="material-icons">account_circle</mat-icon>
              <input class="auth_button_sign_out"
                     type="button"
                     value="サインアウト"
                     onclick="signOut();" />
            </div>
            <div class="spacer"></div>
            <div class="title">
              <a routerLink="/">{{ title$ | async }}</a>
            </div>
            <div class="spacer"></div>
            <ng-container *ngTemplateOutlet="menu ? menu : noMenu"></ng-container>
            @if ((isArtistPage$ | async) && (isPC$ | async)) {
            <button mat-button
                    (click)="downloadPDF()">
              <mat-icon>picture_as_pdf</mat-icon>
              <span class="toolbar-button-label">保存</span>
            </button>
            }
            <button mat-button (click)="onInfoClick()">
              <mat-icon>info_outlined</mat-icon>
              <span class="toolbar-button-label">お知らせ</span>
            </button>
            <a mat-button (click)="onInquiryClick()">
              <mat-icon>group_add</mat-icon>
              <span class="toolbar-button-label">アーティスト追加要望</span>
            </a>
            <button mat-button [matMenuTriggerFor]="searchMenu">
              <mat-icon>search</mat-icon>
              <span class="toolbar-button-label">検索</span>
            </button>
            @if (isArtistPage$ | async) {
            <!-- <button mat-button [matMenuTriggerFor]="dateRangeMenu"> -->
            <input matInput
                   class="date-picker-hidden-input"
                   [matDatepicker]="picker"
                   [matDatepickerFilter]="dateRangeInputFilter"
                   [formControl]="criteriaFromField"
                   (dateChange)="onDateRangeChange()"
                   />
            <mat-datepicker #picker
                            [dateClass]="highlightDate"
                            (closed)="onDateRangeMenuClose()"></mat-datepicker>
            <button mat-button (click)="picker.open()">
              <mat-icon>date_range</mat-icon>
              <span class="toolbar-button-label date-range-label">
                {{ criteriaFrom$ | async | date: 'yyyy-MM-dd' }}
                ~
                {{ criteriaTo$ | async | date: 'yyyy-MM-dd' }}
              </span>
            </button>
            <button mat-button (click)="toggleEventsDrawer()">
              <mat-icon>events</mat-icon>
              <span class="toolbar-button-label">出来事</span>
            </button>
            }
          </mat-toolbar-row>
          @if (isArtistPage$ | async) {
          <mat-toolbar-row class="artist-toolbar-row">
            @if (selectedArtist$ | async; as artist) {
            @if (loaded$ | async) {
            <div class="artist-combined">
              <div fxLayout fxLayoutGap="32px" fxLayoutAlign="space-between end">
                <app-data-field class="artist-tag-item" legend="名前">
                  <span>{{ artist.nameMain }}</span>
                </app-data-field>
                <!-- 別名は空っぽの可能性があります -->
                @if (artist.nameSub) {
                <app-data-field class="artist-tag-item" legend="">
                  <span>{{ artist.nameSub }}</span>
                </app-data-field>
                }
                <app-data-field class="artist-tag-item" legend="ジャンル">
                  <span>{{ artist.genre }}</span>
                </app-data-field>
                <app-data-field class="artist-tag-item" legend="レーベル">
                  <span>{{ artist.label }}</span>
                </app-data-field>
              </div>
            </div>
            <div class="spacer"></div>
            <div class="artist-combined">
              @if (artist.arsha) {
              <img class="arsha" [src]="artist.arsha" />
              }
            </div>
            } @else {
            }
            }
          </mat-toolbar-row>
          }
        </mat-toolbar>
        }

        <ng-content></ng-content>
      </mat-sidenav-content>
            </mat-sidenav-container>



            <mat-menu #searchMenu="matMenu" class="search-artist-menu" (closed)="onArtistQueryClosed()">
              <div class="search-input" (click)="$event.stopPropagation()">
                <mat-form-field appearance="outline" class="query-artist" subscriptSizing="dynamic">
                  <mat-label>Find Artists</mat-label>
                  <input matInput
                         placeholder="Billie Eilish, Taylor Swift, ... etc"
                         [matAutocomplete]="artistComplete"
                         [formControl]="artistQuery" />
                  <button matSuffix mat-icon-button (click)="onSearchArtistClick()">
                    <mat-icon>search</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              </mat-menu>

              <mat-autocomplete
                #artistComplete="matAutocomplete"
                class="search-result-complete"
                (optionSelected)="onArtistsResultSelected($event)"
                [displayWith]="formatOptionValue"
                >
                @if (isArtistsLoading$ | async) {
                  <mat-option disabled>
                    <app-music-note></app-music-note>
                  </mat-option>
                }
                @if (isArtistsLoaded$ | async) {
                  @for (artist of artists$ | async; track artist) {
                    <mat-option
                      [value]="artist"
                      class="search-result-option"
                      >
                      <app-search-artist-result-item [artist]="artist"></app-search-artist-result-item>
                    </mat-option>
                  }
                }
              </mat-autocomplete>

              <!-- スマホアーティストMENU -->

              <!-- スマホトップMENU -->

              <!-- スマホトップバー -->

              <!-- スマホアーティストバー -->
              <ng-template #profileItem let-legend="legend" let-value="value">
                <div class="profile" fxLayout="column">
                  @if (legend) {
                    <div fxFlex="1 1 100%">
                      <span class="profile-legend">
                        {{ legend }}
                      </span>
                    </div>
                  }
                  <div fxFlex="1 1 100%">
                    <span class="profile-value">
                      {{ value }}
                    </span>
                  </div>
                </div>
              </ng-template>
